// @flow
import React from "react";

import { FormInput } from "../form-input/index";
import { Validation } from "../../model/validation";

import { Button } from "../button";

type Props = {
    email: string,
    validation: Validation,
    serverValidateFail: boolean,
    serverValidateMsg: ?string,
    resetted: boolean,
    status: "" | "loading",
    disabledSubmit: boolean,
    submitButtonText: string,
    onEmailChanged: (e: Event, value: string) => any,
    onSubmit: (e: Event) => any
};

export function Recover(props: Props) {
    return props.resetted ? getSuccess(props) : getForm(props);
}

function getSuccess(props: Props) {
    return (
        <form name="recoverPasswordForm" id="recoverPasswordForm">
            <div className="form-row">
                We have sent you a password reset link to {props.email}
                <br />
                Please check your email to proceed.
            </div>
        </form>
    );
}

function getForm(props: Props) {
    return (
        <form
            name="recoverPasswordForm"
            id="recoverPasswordForm"
            onSubmit={props.onSubmit}
        >
            <FormInput
                inputId="email"
                type="email"
                value={props.email}
                label="Email address"
                placeholder="Email address"
                valid={props.validation}
                onChange={props.onEmailChanged}
            />
            {props.serverValidateFail && (
                <div className="form-row">
                    <div
                        className="form-error-msg form-error-msg--server"
                        dangerouslySetInnerHTML={{
                            __html: props.serverValidateMsg
                        }}
                    />
                </div>
            )}
            <div className="form-row form-row-cta">
                <Button
                    id="recover"
                    type="submit"
                    disabled={props.disabledSubmit}
                    status={props.status}
                >
                    {props.submitButtonText}
                </Button>
            </div>
        </form>
    );
}
